import React from 'react';
import { createRoot } from 'react-dom/client';
import $ from 'jquery';
import Scroll from '../utilities/scroll';
import Tooltip from '../utilities/tooltip';
import StorageHandler from '../storage/handler';
import PromoBottom from '../banner/promo_bottom';
import Help from '../utilities/help';
import PostcodeValidator from '../validator/postcode_validator';
import PageFooter from '../_modules/page_footer/page_footer';
import lazyLoadBackground from '../_modules/lazyload_background';
import Cart from '../utilities/cart';
import CartModal from '../utilities/cart_modal';
import MultiLvlContentNav from '../_modules/multi_lvl_content_nav/multi_lvl_content_nav';
import SuggestionBoxContainer from '../_flux/components/search/suggestion_box_container';
import CurrencySetup from '../_modules/currency/currency_setup';
import { CurrentCurrencySetup } from '../_modules/currency/current_currency_setup';
import TranslationActions from '../_flux/actions/translation_actions';
import { applyPostcodeAction } from '../_flux/actions/postcode_actions';
import { initialize } from '../_modules/navigation/initialize';
import {
  setVisibleSectionsAction as setSizeConfiguratorVisibleSection,
  showAction as showSizeConfiguratorAction,
  hideAction as hideSizeConfiguratorAction,
  showAction,
  showFirstLayerAction,
} from '../_flux/actions/catalog_configurator_actions';
import { showAction as showDriverReviewLightbox } from '../_flux/actions/driver_review_light_box_actions';
import {
  show as showCustomerRedirectLighbox,
  hide as hideCustomerRedirectLighbox,
} from '../_flux/actions/customer_redirect_light_box_actions';

import { loadVehicleConfiguratorMake } from '../_modules/vehicle_configurator/get_make';
import { loadVehicleConfiguratorData } from '../_modules/vehicle_configurator/get_vehicle_data';
import { allowVehicleConfiguratorOnStore } from '../_views/vehicle_configurator/show_on_store';
import { isConfiguratorMotoTyreEnabled } from '../_views/configurator/common';
import {
  loadTyreConfiguratorFilterOptions,
  loadTyreMotoConfiguratorFilterOptions,
} from '../_modules/size_configurator/get_filter_options';
import { types as productTypes } from '../_constants/product/types';
import { setConfiguratorType, setPageOriginType } from '../_flux/actions/catalog_configurator_actions';
import CatalogFilterStore from '../_flux/stores/catalog_configurator_store';
import { resetAllFilter } from '../_views/configurator/reset_filters_after_change';
import { updateFilterOptionsAction } from '../_flux/actions/filter_options_actions';
import TyreMotoSizeConfiguratorFilterOptionsStore from '../_flux/stores/configurator_filter_options_store/tyre_moto';
import {
  showAction as showRegoLookupAction,
  hideAction as hideRegoLookupAction,
} from '../_flux/actions/rego_lookup_actions';
import {
  showAction as showVehicleConfiguratorAction,
  hideAction as hideVehicleConfiguratorAction,
} from '../_flux/actions/vehicle_configurator_actions';
import TyreSizeConfiguratorFilterOptionsStore from '../_flux/stores/configurator_filter_options_store/tyre';
// import reportWebVitals from '../../scripts/utilities/web_vitals';
import initServiceFormOnCTA, {
  initializeConfiguratorComponents,
  initServicesForm,
} from '../_views/initialize_component';
import loadPersonyzeTracking from '../utilities/loadPersonyzeTracking';
import loadFreshChat from '../utilities/loadFreshChat';
import loadFriendBuyV2 from '../utilities/loadFriendBuyV2';
import loadSentry from '../utilities/sentry';
import SearchAndReplaceCmsContent from '../utilities/search_replace_cms_content';
import CustomerCountryChoice from '../_modules/customer_country_choice';
import { getShippingPostcode, getShippingState } from '../utilities/local_storage';
import { clearPostcodeFromLocalStorage } from '../utilities/clear_postcode';
import { getPostcodeV2 } from '../_flux/helper/requests/set_postcode_v2';
import onCrossSellDetailsClick from '../_flux/components/sidebar/actions/on_cross_sell_details_click';
import {
  init as initCrossSellLightBox,
  onClose as crossSellLightBoxClose,
} from '../_views/cross_sell_light_box/cross_sell_light_box_view';
import CartActions from '../_flux/actions/cart_actions';
import { isContainerLoadedInDOM, noop } from '../../lib/utilities';
import {
  getCsrfTokenKey,
  getCsrfTokenValue,
  isCsrfTokenExists,
  removeCsrfTokenKeyValue,
} from '../utilities/csrf_token_provider';
import { fetchCsrfToken } from '../_flux/helper/requests/fetch_csrf_token';
import {
  onOpenRegoLookupClick,
  onOpenVehicleConfiguratorClick,
} from '../_views/configurator_buttons/configurator_buttons';
import { homePagePromo, timeSpent10Min } from '../_modules/google_analytics/general';
import { callGAFreeFittingEvent } from '../_modules/google_analytics/free_fitting';
import { initializePageModules } from './landing_page/initialize_page_modules';
import {
  init as initDriverReviewLightBox,
  onClose as driverReviewLightBoxClose,
} from '../_views/driver_review_light_box/driver_review_light_box_view';
import { init as initUILockLightBox } from '../_views/light_box_ui_lock/light_box_ui_lock_view';
import { initializeRotatingBannerSlider } from './landing_page/initialize_rotating_banner_slider';
import CatalogContainersConstants from './catalog/initialize_page_modules/catalog_container_constants';
import FriendBuyAnalytics from '../_modules/google_analytics/friendbuy';
import onEULabelsClick from '../_flux/components/sidebar/actions/on_eu_labels_click';

const DESKTOP_NAVIGATION = 0;
const MOBILE_NAVIGATION = 1;
const MOBILE_MAX_WIDTH = 970;
const MOBILE_NAV_ACTIVE_CSS_CLASS = 'mobile-nav-active';
const LVL3_VISIBLE_CSS_CLASS = 'lvl3-visible';

/**
 * @class Page
 */
class Page {
  static _name = 'Page';

  /**
   * Base class for pages
   * @param {Object} $container
   * @param {FlashMessages} flashMessages
   */
  constructor($container, flashMessages) {
    this.$container = $container;
    this.flashMessages = flashMessages;

    this.navigationType = -1;
    this.mobileNavActive = false;
    this.showDefaultDropdown = true;
    this.new = true;
    this.cart = null;
    this.initialCartRequest = null;
    this.productType = '';
    this.autoOpenTyreConfigurator = false;
    this.autoOpenMotoConfigurator = false;
    this.autoOpenRegoLookup = false;
    this.autoOpenVehicleConfigurator = false;
    this.autoOpenOptionConfigurator = false;
    this.servicesForm = false;
    CurrentCurrencySetup.setCurrentCurrencySetup(CurrencySetup[TYROOLA.globals.currencyIsoCode]);
    loadSentry();
    clearPostcodeFromLocalStorage(TYROOLA.globals);
  }

  /**
   * @return {Page}
   */
  init() {
    initializeRotatingBannerSlider();
    this.addUnhandledRejectionEventListener();
    this.homePageGA4CustomTracking();
    this.sliderRatingClick();
    this.triggerEventAfterXMinutes(10);
    let checkboxes = document.querySelectorAll('#billingMarketingConsent');
    if (checkboxes && checkboxes.length) {
      checkboxes.forEach((cb, idx) => {
        cb.id = cb.id + idx;
        cb.parentElement.firstElementChild.setAttribute('for', cb.id);
      });
    }

    let navigate = document.querySelectorAll('.navigation__level-2.navigation-level-2');
    let persistElement = {};
    let persistEventElement = [];

    navigate.forEach((nav, idx) => {
      persistEventElement[idx] = nav.parentNode.firstElementChild.classList[1];
      persistElement[nav.parentNode.classList[1]] = nav.parentNode.innerHTML;
      nav.innerHTML = '';
    });

    persistEventElement.forEach((evElem) => {
      const elem = document.querySelector(`.${evElem}, .${evElem} .navigation-level-2__content-container`);

      elem.addEventListener('mouseover', (event) => {
        const level2 = document.querySelector(
          `.${evElem.replace('link', 'item')} .navigation__level-2.navigation-level-2`,
        );
        level2.style.visibility = 'visible';
        level2.style.opacity = '1';
        level2.style.transition = 'visibility 0s linear .2s,opacity .2s ease-out .2s';

        if (
          event.currentTarget.parentNode &&
          event.currentTarget.parentNode.classList &&
          event.currentTarget.parentNode.classList[1]
        ) {
          const elemIdx = event.currentTarget.parentNode.classList[1];
          const html = persistElement[elemIdx];
          level2.parentNode.innerHTML = html;
        }

        initServiceFormOnCTA('a[href*="#openServiceFinder"]', () => {}, initServicesForm); //bind service form to CTA Button
        const staticUrl = TYROOLA.globals.staticUrl;
        const options = { productType: 'tyre', staticUrl };
        initServiceFormOnCTA(
          'a[href*="#open-vehicle-configurator"]',
          initializeConfiguratorComponents.bind(this, options),
          onOpenVehicleConfiguratorClick,
        );
        initServiceFormOnCTA(
          'a[href*="#open-rego-lookup"]',
          initializeConfiguratorComponents.bind(this, options),
          onOpenRegoLookupClick,
        );
      });
    });

    initServiceFormOnCTA(
      'a[href*="/v1/tyre/michelin/?s=relevance&d=desc&free_fitting=1"]',
      (e) => (location.href = e),
      callGAFreeFittingEvent,
      noop,
      1,
    );

    // Open Cross Sell Lightbox on Click
    const lightContentAvailable = document.querySelectorAll('.light-content-available');
    if (lightContentAvailable.length) {
      lightContentAvailable.forEach((lca) => {
        if (lca.offsetParent) {
          lca.style.cursor = 'pointer';

          lca.addEventListener('click', () => {
            const id = lca.dataset.spinachId;
            const title = lca.dataset.title || '';
            onCrossSellDetailsClick({ spinachId: id, title: title });
          });
        }
      });
    }

    this.updateHrefsWithPrefix();
    Page.attachEuLabelsLightboxOnClick();
    this.updateCsrfLocalStorage();
    // reportWebVitals();
    lazyLoadBackground(); // bind lazy load image observer
    SearchAndReplaceCmsContent();
    if (this.$container.length) {
      if (location.href.indexOf('/checkout/success') === -1) {
        Page.initFetchCsrfToken();
      }
      this.productType = $('.catalog-moto-tyres').length ? productTypes.TYRE_MOTO : productTypes.TYRE_CAR;
      if (productTypes.TYRE_MOTO === this.productType) {
        setPageOriginType(productTypes.TYRE_MOTO);
        setConfiguratorType(productTypes.TYRE_MOTO);
      } else {
        setPageOriginType(productTypes.TYRE_CAR);
        setConfiguratorType(productTypes.TYRE_CAR);
      }
    }

    const urlParams = new URLSearchParams(window.location.search);
    const tyreConfigurator = urlParams.get('open_configurator');
    const motoConfigurator = urlParams.get('open_moto_configurator');
    const serviceForm = urlParams.get('service_form');
    const regoLookup = urlParams.get('open_rego_lookup');
    const vehicleConfigurator = urlParams.get('open_vehicle_configurator');
    const optionConfigurator = urlParams.get('open_option_configurator');

    if (urlParams && tyreConfigurator === '1' && !serviceForm) {
      this.autoOpenTyreConfigurator = true;
    }

    if (urlParams && motoConfigurator === '1' && !serviceForm) {
      this.autoOpenMotoConfigurator = true;
    }

    if (urlParams && regoLookup === '1' && !serviceForm) {
      this.autoOpenRegoLookup = true;
    }

    if (urlParams && vehicleConfigurator === '1' && !serviceForm) {
      this.autoOpenVehicleConfigurator = true;
    }

    if (urlParams && optionConfigurator === '1' && !serviceForm) {
      this.autoOpenOptionConfigurator = true;
    }

    if (urlParams.get('service_form')) {
      this.servicesForm = true;
    }

    this.initBackToTopButton().initTooltips().initTyreSizeHelp().initNavigation();
    // .initSearchSuggestionBox()

    Page.initHelp();
    this.validateCMSConfiguratorPostcode();
    this.initFooter();
    this.initSCHeader();
    this.updateHeaderCartInformation(false);
    this.handleFooterMultiLvlContentNav();
    this.initZipPay();
    this.initReviewsTyroola();
    this.initReviewsFitting();
    this.initShopAddToCartAppendCsrfToken();

    Page.initializeTranslations()
      .initCustomerRedirectLightbox()
      .OpenDialogsOnQueryParams(
        this.autoOpenTyreConfigurator,
        this.autoOpenMotoConfigurator,
        this.servicesForm,
        this.autoOpenRegoLookup,
        this.autoOpenVehicleConfigurator,
        this.autoOpenOptionConfigurator,
      )
      .initializeNavigation()
      .initFetchVehicleConfiguratorData()
      .initConfiguratorTriggers()
      .initVehicleConfiguratorMake();
    if (navigator.userAgent.indexOf('GTmetrix') === -1 && location.href.indexOf('disablePersonyze=1') === -1) {
      let storeUrl = TYROOLA.globals.storeUrl;
      storeUrl = storeUrl.substring(storeUrl.indexOf('://') + 3);
      loadPersonyzeTracking(storeUrl);
    }
    initializePageModules('tyre', TYROOLA.globals.staticUrl);
    initServiceFormOnCTA('a[href*="#openServiceFinder"]', () => {}, initServicesForm); //bind service form to CTA Button
    loadFreshChat();

    if (location.href.indexOf('disableFriendbuy=1') === -1) {
      loadFriendBuyV2();
    }

    this._setPostcodeOnDemand();

    initDriverReviewLightBox(document.getElementById('driver-review'), {});
    initUILockLightBox(document.getElementById('lightbox-ui'), {});
    const isCrossSellAvailable = document.getElementById('cross-sell');

    if (isCrossSellAvailable) {
      initCrossSellLightBox(isCrossSellAvailable, {});
    }
    CartActions.loadCartAction();

    if (location.href.indexOf('checkout/success') !== -1) {
      this._pushFriendBuyEvents();
    }
    this.initializeCopyToClipboard();
    Page.initStickyElement('.button-addtocart-cms-section', '.button-addtocart-cms-section-sticky', true);
    this.initCmsAccordion();
    this.friendBuySubscribeEvents();

    return this;
  }

  static attachEuLabelsLightboxOnClick() {
    // Open EU Labels Lightbox on Click
    const euLabelsLightContentAvailable = document.querySelectorAll('#eu-labels-container');
    if (euLabelsLightContentAvailable.length) {
      euLabelsLightContentAvailable.forEach((lca) => {
        if (lca.offsetParent) {
          lca.style.cursor = 'pointer';

          lca.addEventListener('click', () => {
            const id = lca.dataset.spinachId;
            const title = lca.dataset.title || '';
            onEULabelsClick({ spinachId: id, title: title });
          });
        }
      });
    }
  }

  initCmsAccordion() {
    const descAccordion = document.querySelector('.js-toggle-accordion');

    if (descAccordion) {
      descAccordion.addEventListener('click', function () {
        if (this.parentElement.className.indexOf('product-toggle--opened') === -1) {
          this.parentElement.classList.add('product-toggle--opened');
        } else {
          this.parentElement.classList.remove('product-toggle--opened');
        }
      });
    }

    return this;
  }

  static initStickyElement(selector, stickySelector, allowTop) {
    const elem = document.querySelector(selector);
    const stickyElem = document.querySelectorAll(stickySelector);

    this.toggleStickyElement(elem, stickyElem, allowTop);
    document.addEventListener('scroll', () => {
      this.toggleStickyElement(elem, stickyElem, allowTop);
    });

    return this;
  }

  static toggleStickyElement(elem, stickyElem, allowTop) {
    if (elem && stickyElem) {
      const isElemDisabled = elem.querySelector('button')?.disabled;
      if (isElemDisabled) {
        return;
      }
      const isVisible = this.isScrolledIntoView(elem, allowTop);
      if (isVisible) {
        elem.style.opacity = 1;
        stickyElem.forEach((e) => {
          e.style.opacity = 0;
          e.style.height = '0';
          e.style.marginTop = '-1000px';
        });
      } else {
        elem.style.opacity = 0;
        stickyElem.forEach((e) => {
          e.style.opacity = 1;
          e.style.height = '';
          e.style.marginTop = '';
        });
      }
    }
  }

  static isScrolledIntoView(elem, allowTop) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();

    var element = $(elem);
    if (element && element.offset() && element.offset().top) {
      var elemTop = element.offset().top;
      var elemBottom = elemTop + element.height();

      if (allowTop) {
        return elemTop < docViewBottom && elemBottom >= docViewTop;
      }
      return elemBottom >= docViewTop;
    }
    return false;
  }

  initializeCopyToClipboard() {
    const clipboardElems = document.getElementsByClassName('copy-to-clipboard');
    if (clipboardElems.length > 0) {
      for (let i = 0; i < clipboardElems.length; i++) {
        clipboardElems.item(i).addEventListener('click', this.copyToClipboard, false);
      }
    }
  }

  copyToClipboard(ev) {
    const parentNode = ev.target.parentNode;
    const copyText = parentNode.getElementsByClassName('copy-text');

    if (copyText && copyText[0] && copyText[0].innerHTML) {
      navigator.clipboard.writeText(copyText[0].innerHTML.trim());

      const bubbles = parentNode.getElementsByClassName('clipboard-bubble');
      if (bubbles.length > 0) {
        return;
      }

      const bubble = document.createElement('label');
      bubble.style.margin = '0';
      bubble.classList.add('clipboard-bubble');
      bubble.innerHTML = 'Copied to your clipboard!';
      parentNode.appendChild(bubble);

      setTimeout(() => {
        bubble.remove();
      }, 800);
    }
  }

  _pushFriendBuyEvents() {
    setTimeout(() => {
      let friendBuyData = document.getElementById('friendbuyData');

      if (friendBuyData) {
        friendBuyData = JSON.parse(friendBuyData.dataset['friendbuy']);
        let _friendbuyConversion = friendBuyData.friendbuyConversion;
        let _friendbuySmartPixel = friendBuyData.friendbuySmartPixel;

        friendbuyAPI.push([
          'track',
          'purchase',
          {
            id: _friendbuyConversion.orderNumber,
            amount: _friendbuyConversion.total,
            currency: _friendbuyConversion.currency,
            isNewCustomer: _friendbuyConversion.isNewCustomer,
            customer: {
              email: _friendbuySmartPixel.email,
              name: `${_friendbuySmartPixel.firstName} ${_friendbuySmartPixel.lastName}`,
              id: _friendbuySmartPixel.customerId,
            },
            products: _friendbuyConversion.products,
          },
        ]);
      }
    }, 500);
  }

  friendBuySubscribeEvents() {
    friendbuyAPI.push([
      'subscribe',
      'widgetActionTriggered',
      function (action) {
        if (action.actionName === 'advocateEmailCaptured') {
          FriendBuyAnalytics.clickStartSharingAction(action);
        } else if (action.actionName === 'transitionScreen') {
          FriendBuyAnalytics.clickShareAgainAction(action);
        } else if (action.actionName === 'emailShare') {
          FriendBuyAnalytics.clickSendAction(action);
        } else if (action.actionName === 'facebookShare') {
          FriendBuyAnalytics.clickFacebookShareAction(action);
        } else if (action.actionName === 'messengerShare') {
          FriendBuyAnalytics.clickMessengerShareAction(action);
        } else if (action.actionName === 'twitterShare') {
          FriendBuyAnalytics.clickTwitterShareAction(action);
        }
      },
    ]);
  }

  addUnhandledRejectionEventListener() {
    window.addEventListener('unhandledrejection', (event) => {
      console.warn(`UNHANDLED PROMISE REJECTION: ${event.reason}`);
    });
  }

  homePageGA4CustomTracking() {
    const section = document
      .querySelector('.content-section--default')
      ?.querySelectorAll('.teaser-section__teaser img.teaser__image');

    if (section) {
      section.forEach((elem, idx) => {
        elem.dataset.sequence = idx + 1;

        elem.addEventListener('click', (event) => {
          const { sequence } = event.target.dataset;
          let promoName = event.target.src;
          promoName = promoName.substring(promoName.lastIndexOf('/') + 1, promoName.lastIndexOf('.'));
          promoName = promoName.replaceAll('_', ' ');
          promoName = promoName.replaceAll('-', ' ');

          homePagePromo(sequence, promoName);
        });
      });
    }
  }

  sliderRatingClick() {
    const allDriverReviewLinkElement = document.querySelectorAll('div[data-review-link-click]');

    if (allDriverReviewLinkElement) {
      allDriverReviewLinkElement.forEach((elem) => {
        elem.addEventListener('click', (event) => {
          event.preventDefault();
          const manufacturer = event.currentTarget.dataset.manufacturer;
          const model = event.currentTarget.dataset.model;
          if (manufacturer && model) {
            showDriverReviewLightbox({ manufacturer, model });
          }
        });
      });
    }
  }

  triggerEventAfterXMinutes(min) {
    setTimeout(
      () => {
        timeSpent10Min();
      },
      min * 60 * 1000,
    );
  }

  updateHrefsWithPrefix() {
    const urlPrefix = TYROOLA.globals.urlPrefix;
    if (urlPrefix && location.href.indexOf('/checkout/success') !== -1) {
      const referHrefs = document.querySelectorAll('a[href="/refer/"]');

      if (referHrefs.length) {
        referHrefs.forEach((rh, idx) => {
          rh.setAttribute('href', `${urlPrefix}/refer/`);
        });
      }
    }
    return this;
  }

  updateCsrfLocalStorage() {
    if (location.href.indexOf('/checkout/success') !== -1) {
      removeCsrfTokenKeyValue();
    }
    return this;
  }

  static async initFetchCsrfToken() {
    await fetchCsrfToken();
    return this;
  }

  static initFetchVehicleConfiguratorData() {
    const { store } = TYROOLA.globals;
    if (allowVehicleConfiguratorOnStore(store)) {
      try {
        loadVehicleConfiguratorData();
      } catch (error) {
        console.warn("Couldn't fetch vehicle configurator data: " + error);
      }
    }

    return this;
  }

  static initVehicleConfiguratorMake() {
    const { store } = TYROOLA.globals;
    if (allowVehicleConfiguratorOnStore(store)) {
      try {
        loadVehicleConfiguratorMake();
      } catch (error) {
        console.warn("Couldn't fetch vehicle configurator make: " + error);
      }
    }

    return this;
  }

  static OpenDialogsOnQueryParams(
    autoOpenTyreConfigurator,
    autoOpenMotoConfigurator,
    servicesForm,
    autoOpenRegoLookup,
    autoOpenVehicleConfigurator,
    autoOpenOptionConfigurator,
  ) {
    try {
      const pageOriginType = CatalogFilterStore.getState().pageOriginType;

      let isMoto = false;
      let isCar = false;
      let isCarToMoto = false;
      let isMotoToCar = false;
      const staticUrl = TYROOLA.globals.staticUrl;
      const options = { productType: 'tyre', staticUrl };

      if (servicesForm) {
        initServicesForm();
      } else if (autoOpenOptionConfigurator) {
        showFirstLayerAction();
        initializeConfiguratorComponents(options, true);

        hideVehicleConfiguratorAction();
        hideRegoLookupAction();
        showSizeConfiguratorAction();
      } else if (autoOpenRegoLookup) {
        initializeConfiguratorComponents(options, true);

        hideVehicleConfiguratorAction();
        hideSizeConfiguratorAction();
        showRegoLookupAction();
      } else if (autoOpenVehicleConfigurator) {
        initializeConfiguratorComponents(options, true);

        hideRegoLookupAction();
        hideSizeConfiguratorAction();
        showVehicleConfiguratorAction();
      }
      if (pageOriginType === productTypes.TYRE_CAR && autoOpenMotoConfigurator) {
        hideCustomerRedirectLighbox();
        isCarToMoto = true;
      } else if (pageOriginType === productTypes.TYRE_MOTO && autoOpenMotoConfigurator) {
        hideCustomerRedirectLighbox();
        isMoto = true;
      }

      if (pageOriginType === productTypes.TYRE_MOTO && autoOpenTyreConfigurator) {
        hideCustomerRedirectLighbox();
        isMotoToCar = true;
      } else if (pageOriginType === productTypes.TYRE_CAR && autoOpenTyreConfigurator) {
        hideCustomerRedirectLighbox();
        isCar = true;
      }

      let doAutoOpen = false;
      if (true === isConfiguratorMotoTyreEnabled()) {
        doAutoOpen = isCar || isCarToMoto || isMoto || isMotoToCar;
      } else {
        doAutoOpen = isCar || isCarToMoto;
      }

      loadTyreConfiguratorFilterOptions(doAutoOpen).then(() => {
        if (isMotoToCar) {
          options.productType = 'moto';
          initializeConfiguratorComponents(options, true);
          setConfiguratorType(productTypes.TYRE_CAR);
          setSizeConfiguratorVisibleSection(['indexes', 'postcode', 'sizes']);
          resetAllFilter(productTypes.TYRE_CAR);
          updateFilterOptionsAction(TyreSizeConfiguratorFilterOptionsStore.getState());

          hideRegoLookupAction();
          hideVehicleConfiguratorAction();
          showSizeConfiguratorAction();
        } else if (isCar) {
          initializeConfiguratorComponents(options, true);
          setConfiguratorType(productTypes.TYRE_CAR);
          setSizeConfiguratorVisibleSection(['indexes', 'postcode', 'sizes']);
          updateFilterOptionsAction(TyreSizeConfiguratorFilterOptionsStore.getState());

          hideRegoLookupAction();
          hideVehicleConfiguratorAction();
          showSizeConfiguratorAction();
        }
      });

      if (true === isConfiguratorMotoTyreEnabled()) {
        loadTyreMotoConfiguratorFilterOptions(doAutoOpen).then(() => {
          if (isCarToMoto) {
            initializeConfiguratorComponents({}, true);
            setConfiguratorType(productTypes.TYRE_MOTO);
            setSizeConfiguratorVisibleSection(['indexes', 'postcode', 'sizes']);
            resetAllFilter(productTypes.TYRE_MOTO);
            updateFilterOptionsAction(TyreMotoSizeConfiguratorFilterOptionsStore.getState());

            hideRegoLookupAction();
            hideVehicleConfiguratorAction();
            showSizeConfiguratorAction();
          } else if (isMoto) {
            initializeConfiguratorComponents({}, true);
            setConfiguratorType(productTypes.TYRE_MOTO);
            setSizeConfiguratorVisibleSection(['indexes', 'postcode', 'sizes']);
            updateFilterOptionsAction(TyreMotoSizeConfiguratorFilterOptionsStore.getState());

            hideRegoLookupAction();
            hideVehicleConfiguratorAction();
            showSizeConfiguratorAction();
          }
        });
      }
    } catch (error) {
      console.warn("Couldn't fetch size configurator filter options: " + error);
    }

    return this;
  }

  static initConfiguratorTriggers() {
    $('.js-open-configurator').on('click', (e) => e.preventDefault() ^ showAction());
    return this;
  }

  static initializeTranslations() {
    TranslationActions.updateAction(TYROOLA.translations);
    return Page;
  }

  static initializeNavigation() {
    initialize();
    return Page;
  }

  static initCustomerRedirectLightbox() {
    const customerChoice = new CustomerCountryChoice();
    const shouldDisplayCountryChoice = customerChoice.shouldDisplayCountryChoice();
    const container = document.getElementById('customer-redirect-lightbox');

    if (container && shouldDisplayCountryChoice) {
      import(
        /* webpackChunkName: "customerRedirect" */ '../_views/customer_redirect_lightbox/customer_redirect_lightbox'
      ).then((component) => {
        component.init(container, {});
        showCustomerRedirectLighbox();
      });
    }

    return this;
  }

  handleFooterMultiLvlContentNav() {
    const nav = new MultiLvlContentNav();

    if (nav.listsFound()) {
      nav.registerEvents();
      nav.onWindowResize();
    }

    return this;
  }

  /**
   * @returns {Page}
   */
  initTooltips() {
    const tooltips = [];

    $('.tooltip-init:not(.tooltipstered)').each((key, el) => {
      const tooltip = new Tooltip($(el));
      tooltip.init();
      tooltips.push(tooltip);
    });

    this.tooltips = tooltips;

    return this;
  }

  /**
   * @returns {Page}
   */
  initBackToTopButton() {
    $('#back-to-top').on('click', () => Scroll.to($('body')));
    return this;
  }

  /**
   * @returns {Page}
   */
  initPromoBanner() {
    this.promoBanner = new PromoBottom($('#promo-bottom'), new StorageHandler());
    this.promoBanner.init();

    return this;
  }

  /**
   * @return {Array}
   */
  getTrackerConfig() {
    return ['ShippingCostTracker', 'AutoSuggestTracker', 'FooterTracker', 'EnhancedEcommerceTracker'];
  }

  initTyreSizeHelp() {
    $(document).on('click', '[data-tyre-size-help]', function (event) {
      event.preventDefault();
      const target = $(this),
        imageUrl = target.data('tyre-size-help'),
        replace = target.data('replace');

      if (typeof replace !== 'undefined') {
        target.attr('src', imageUrl);
      } else {
        $.featherlight($('<img/>', { src: imageUrl }));
      }
    });

    return this;
  }

  static initHelp() {
    new Help().init();
  }

  /**
   *
   * Navigation
   *
   **/
  initNavigation() {
    this.checkForNavigationType();
    this.checkForSpecificBrowser();
    this.registerThirdLevelHoverImageReplacement('.cheap-tyre-deals-list', '.cheap-tyre-deal');
    this.registerThirdLevelHoverImageReplacement('.guides-nav-list', '.guides-nav-item');

    const $body = $(document.body);
    $('.js-kogan-toggle-mobile-navigation').on('click', (evt) => {
      evt.preventDefault();
      $body.toggleClass('mobile-nav-active');
    });

    return this;
  }

  checkForSpecificBrowser() {
    const UA = navigator.userAgent;

    if (UA.match(/Firefox/) && UA.match(/OS X/)) {
      $(document.body).addClass('ff-osx');
    }
  }

  onNavigationTypeChange() {
    this.bindOrRemoveThirdLevelDisplayChangeEvent();
    this.bindOrRemoveToggleMobileNavBtnClickEvent();
    this.bindOrRemoveOpenSubOnClickEvent();
  }

  checkNavigationTypeOnWindowResize() {
    let typeChanged = false;

    if (window.innerWidth > MOBILE_MAX_WIDTH && this.navigationType !== DESKTOP_NAVIGATION) {
      this.navigationType = DESKTOP_NAVIGATION;
      typeChanged = true;
    } else if (window.innerWidth < MOBILE_MAX_WIDTH + 1 && this.navigationType !== MOBILE_NAVIGATION) {
      this.navigationType = MOBILE_NAVIGATION;
      typeChanged = true;
    }

    if (typeChanged) {
      this.onNavigationTypeChange();
    }
  }

  checkForNavigationType() {
    $(window).on('resize', this.checkNavigationTypeOnWindowResize.bind(this));
    this.checkNavigationTypeOnWindowResize();
  }

  bindOrRemoveThirdLevelDisplayChangeEvent() {
    if (this.navigationType === DESKTOP_NAVIGATION) {
      $('.main-navigation-sub-tyre').on(
        'mouseover.navLvl2Hover',
        '.main-navigation-lvl2-item',
        this.onSecondLevelHover,
      );
    } else {
      $('.main-navigation-sub-tyre').off('mouseover.navLvl2Hover');
    }
  }

  bindOrRemoveToggleMobileNavBtnClickEvent() {
    if (this.navigationType === DESKTOP_NAVIGATION) {
      $('.toggle-mobile-navigation-btn').off('click.toggleNav');
      $(document.body).removeClass(MOBILE_NAV_ACTIVE_CSS_CLASS);
    } else {
      $('.toggle-mobile-navigation-btn').on('click.toggleNav', this.onToggleMobileNavBtnClick);
    }
  }

  bindOrRemoveOpenSubOnClickEvent() {
    if (this.navigationType === DESKTOP_NAVIGATION) {
      $('.main-navigation-has-sub .main-navigation__toggle-second-lvl').off('click.toggleSub');
    } else {
      $('.main-navigation-has-sub .main-navigation__toggle-second-lvl').on(
        'click.toggleSub',
        this.onToggleSubNavBtnClick,
      );
    }
  }

  onSecondLevelHover() {
    let lvl2ItemCSSIndex, $lvl3Items;

    lvl2ItemCSSIndex = $(this).index() + 1;
    $lvl3Items = $('.main-navigation-sub-tyre-lvl3');

    $lvl3Items
      .removeClass(LVL3_VISIBLE_CSS_CLASS)
      .filter(`:nth-child(${lvl2ItemCSSIndex})`)
      .addClass(LVL3_VISIBLE_CSS_CLASS);
  }

  onToggleMobileNavBtnClick() {
    let $body;

    $body = $(document.body);
    if (this.mobileNavActive) {
      $body.removeClass(MOBILE_NAV_ACTIVE_CSS_CLASS);
    } else {
      $body.addClass(MOBILE_NAV_ACTIVE_CSS_CLASS);
    }
    this.mobileNavActive = !this.mobileNavActive;
  }

  onToggleSubNavBtnClick(e) {
    let $this, subNav;

    $this = $(this);
    subNav = $this.parent().next();

    if (!subNav.get(0).className.match(/cart/)) {
      e.preventDefault();
    }

    $this.parents('.main-navigation-lvl1-item').toggleClass('sub-nav-opened');
  }

  registerThirdLevelHoverImageReplacement(containerClassName, imageInfoClassName) {
    const navImage = document.querySelector('.tyres-nav-image');
    if (!navImage) {
      return;
    }

    const navImageOrigSrc = navImage.src;

    $(containerClassName)
      .on('mouseover', imageInfoClassName, function () {
        navImage.src = this.getAttribute('data-hover-image') || navImageOrigSrc;
      })
      .on('mouseout', function () {
        navImage.src = navImageOrigSrc;
      });
  }

  validateCMSConfiguratorPostcode() {
    const configuratorForm = $('.configurator-v2 form');
    if (!configuratorForm.length) {
      return;
    }

    configuratorForm.on('submit', () => {
      const postcodeInput = configuratorForm.find('.index__postcode');
      const postcode = postcodeInput.val();
      this.hideInvalidPostcodeMessage(postcodeInput);
      if (!new PostcodeValidator().isValid(postcode)) {
        this.showInvalidPostcodeMessage(postcodeInput);
        return false;
      }
    });
  }

  showInvalidPostcodeMessage($postcodeInput) {
    $postcodeInput.next().addClass('postcode-error-msg--visible');
  }

  hideInvalidPostcodeMessage($postcodeInput) {
    $postcodeInput.next().removeClass('postcode-error-msg--visible');
  }

  initFooter() {
    new PageFooter();
    return this;
  }

  initSCHeader() {
    const $body = $('body');

    $('.sca-header__mobile-nav-trigger').on('click', () => {
      $body.toggleClass('show-mobile-nav');
    });
    $('.nrma-nav-trigger').on('click', () => {
      $body.toggleClass('show-nrma-mobile-nav');
    });

    return this;
  }

  updateHeaderCartInformation(retrieveCartOnly = true) {
    const shouldRequestCart = $('.sca-nav-header-meta--cart .sca-nav-header-meta__link').length;

    if (shouldRequestCart) {
      this.initialCartRequest = this.getCart(retrieveCartOnly).done(this.showCartDetailsInHeader.bind(this));
    }

    return this;
  }

  getCart() {
    let cart;

    if (this.cart) {
      cart = this.cart;
    } else {
      this.cart = cart = new Cart();
    }

    return cart.retreiveContents();
  }

  showCartDetailsInHeader() {
    let $header, $cartLinks;

    // const postcode = this.cart.getPostcode();
    // if (postcode) {
    //   applyPostcodeAction(postcode);
    // }

    $cartLinks = $('.sca-nav-header-meta--cart .sca-nav-header-meta__link');

    if ($cartLinks.length) {
      const cartItems = this.cart.getCartProducts();
      const cartCountClassName = 'sca-header__cart-count';

      if (cartItems.length) {
        $cartLinks.append(
          $(`
                    <span class="${cartCountClassName}">
                    ${cartItems.length}
                    </span>
                `),
        );
      }
    }
  }

  addCartModel() {
    let cartModal, modalHTML, amount;

    amount = this.cart.getTotalsWithoutExpenses();

    cartModal = new CartModal();
    cartModal.setCustomerName(this.cart.getCustomerName());
    cartModal.setProducts(this.cart.getCartProducts());
    cartModal.setExpenses(amount);

    modalHTML = cartModal.getRenderedModal();
    $('.main-navigation-cart-item').append($(modalHTML));
    $('.main-navigation-cart-item .main-navigation-lvl1-link').addClass('main-navigation-has-sub');
  }

  /**
   * @returns {Page}
   */
  initSearchSuggestionBox() {
    const container = document.getElementById('search-suggestion-container');

    if (!container) {
      return;
    }

    if (!isContainerLoadedInDOM(container)) {
      TYROOLA.root[container.id] = createRoot(container);
    }
    TYROOLA.root[container.id].render(React.createElement(SuggestionBoxContainer));

    return this;
  }

  /**
   *
   */
  initZipPay() {
    $('[data-zippay-featherlight]').on('click', (e) => {
      e.preventDefault();
      $.featherlight(TYROOLA.globals.baseUrl + '/zipmoney/zippay/', {
        type: 'ajax',
        afterOpen: Page.addZippayCssModifierToLightbox,
        beforeClose: Page.unfixBody,
      });
    });
  }

  initReviewsTyroola() {
    let rating = {
      init: function ($container) {
        this.$container = $container;
        this.attachEvents();
      },
      attachEvents: function () {
        this.$container.find('span').on('mouseover', $.proxy(this.mouseOver, this));
        this.$container.find('span').on('click', $.proxy(this.click, this));
        this.$container.find('span').on('mouseout', $.proxy(this.mouseOut, this));
        this.$container.find('span').each(function (i, el) {
          var container = $(el).parent(),
            index = $(el).data('index'),
            review = $(container.data('review')).val();

          if (parseInt(index) > parseInt(review)) {
            $(el).addClass('icon-star-empty-lg').removeClass('icon-star-full-lg');
          }
        });
      },
      mouseOver: function (event) {
        var index = $(event.target).data('index'),
          container = $(event.target).parent();

        container.find('span').each(function (i, el) {
          if (index >= $(el).data('index')) {
            $(el).addClass('icon-star-full-lg');
            $(el).removeClass('icon-star-empty-lg');
          } else {
            $(el).removeClass('icon-star-full-lg');
            $(el).addClass('icon-star-empty-lg');
          }
        });
      },
      click: function (event) {
        var container = $(event.target).parent(),
          index = $(event.target).data('index');

        container.find('span').each(function (i, el) {
          $(el).removeClass('selected');
        });

        $(container.data('review')).val(index);
        $(event.target).addClass('selected');
      },
      mouseOut: function (event) {
        var container = $(event.target).parent(),
          index = container.find('.selected').data('index');

        if (typeof index == 'undefined') {
          index = 5;
        }

        container.find('span').each(function (i, el) {
          if (index >= $(el).data('index')) {
            $(el).addClass('icon-star-full-lg');
            $(el).removeClass('icon-star-empty-lg');
          } else {
            $(el).removeClass('icon-star-full-lg');
            $(el).addClass('icon-star-empty-lg');
          }
        });
      },
    };
    rating.init($('.review-stars'));
  }

  initReviewsFitting() {
    let rating = {
      init: function ($container) {
        this.$container = $container;
        this.attachEvents();
      },
      attachEvents: function () {
        this.$container.find('span').on('mouseover', $.proxy(this.mouseOver, this));
        this.$container.find('span').on('click', $.proxy(this.click, this));
        this.$container.find('span').on('mouseout', $.proxy(this.mouseOut, this));
        this.$container.find('span').each(function (i, el) {
          var container = $(el).parent(),
            index = $(el).data('index'),
            review = $(container.data('review')).val();

          if (parseInt(index) > parseInt(review)) {
            $(el).addClass('icon-star-empty-lg').removeClass('icon-star-full-lg');
          }
        });
      },
      mouseOver: function (event) {
        var index = $(event.target).data('index'),
          container = $(event.target).parent();

        container.find('span').each(function (i, el) {
          if (index >= $(el).data('index')) {
            $(el).addClass('icon-star-full-lg');
            $(el).removeClass('icon-star-empty-lg');
          } else {
            $(el).removeClass('icon-star-full-lg');
            $(el).addClass('icon-star-empty-lg');
          }
        });
      },
      click: function (event) {
        var container = $(event.target).parent(),
          index = $(event.target).data('index');

        container.find('span').each(function (i, el) {
          $(el).removeClass('selected');
        });

        $(container.data('review')).val(index);
        $(event.target).addClass('selected');
      },
      mouseOut: function (event) {
        var container = $(event.target).parent(),
          index = container.find('.selected').data('index');

        if (typeof index == 'undefined') {
          index = 5;
        }

        container.find('span').each(function (i, el) {
          if (index >= $(el).data('index')) {
            $(el).addClass('icon-star-full-lg');
            $(el).removeClass('icon-star-empty-lg');
          } else {
            $(el).removeClass('icon-star-full-lg');
            $(el).addClass('icon-star-empty-lg');
          }
        });
      },
    };
    rating.init($('.review-stars'));
  }

  initShopAddToCartAppendCsrfToken() {
    const addToCartButton = $('.button-addtocart-shop-section');
    addToCartButton.on('click', function (e) {
      const formAddToCart = this.form;

      const csrfTokenKeyInput = document.createElement('input');
      csrfTokenKeyInput.setAttribute('type', 'hidden');
      csrfTokenKeyInput.setAttribute('name', getCsrfTokenKey());
      csrfTokenKeyInput.setAttribute('value', getCsrfTokenValue());
      formAddToCart.appendChild(csrfTokenKeyInput);
    });

    return this;
  }

  static formAppendCsrfToken(form) {
    const csrfTokenKeyInput = document.createElement('input');
    csrfTokenKeyInput.setAttribute('type', 'hidden');
    csrfTokenKeyInput.setAttribute('name', getCsrfTokenKey());
    csrfTokenKeyInput.setAttribute('value', getCsrfTokenValue());
    $(form).append(csrfTokenKeyInput);
  }

  _setPostcodeOnDemand() {
    if (!getShippingPostcode() || !getShippingState()) {
      getPostcodeV2().then((response) => response && applyPostcodeAction(response.autoSuggestLabel));
    }
  }

  static addZippayCssModifierToLightbox() {
    Page.fixBody();
    $('.zippay-light-box').parents('.featherlight').addClass('featherlight--zippay');
  }

  static fixBody() {
    $(document.body).addClass('prevent-scroll');
  }

  static unfixBody() {
    $(document.body).removeClass('prevent-scroll');
  }
}

export default Page;
